import { t } from "i18next";
import React from "react";
import { FaCalendarAlt } from "react-icons/fa";

interface CustomDatePickerInputProps {
    value?: string;
    onClick?: () => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    error?: boolean;
}

const CustomDatePickerInput = React.forwardRef<HTMLInputElement, CustomDatePickerInputProps>(
    ({ value, onClick, onChange, error }, ref) => (
        <div className="relative w-full">
            <input
                value={value}
                onClick={onClick}
                onChange={onChange}
                ref={ref}
                className={`border ${error ? 'border-red' : 'border-[#6F6F6F]'} input-text leading-[18px] text-black text-[15px] bg-white border  rounded-[8px] p-[10px] w-full`}
                placeholder={t('screens.profile.deteFormat') as string}
            />
            <FaCalendarAlt className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none" />
        </div>
    )
);

CustomDatePickerInput.displayName = "CustomDatePickerInput";
export default CustomDatePickerInput;
